/* @ngInject */
function AssetPreviewTabsUserController ($scope, $translate, $timeout, $sce, $rootScope, ToastService, Utils, TemplateService, AssetService) {
  $scope.location = $scope.location || 'materials'
  $scope.isSingleTab = $scope.location === 'materials'
  $scope.title = null
  $scope.type = null
  $scope.productTitle = null
  $scope.size = null
  $scope.dimensions = null
  $scope.usageInstructions = null
  $scope.categories = []
  $scope.expirationDate = null
  $scope.approval = false
  $scope.previewFlags.tabHasNewComment = $scope.template?.unreadComments > 0 || $scope.contextData?.task?.unreadComments
  $scope.flags = {
    loadingContent: false
  }

  const api = {
    _truncateText,
    _formatDate,
    _handleTemplateDetails,
    _getAssetType,
    _getTemplateDimensions,
    _getSize,
    _getInstructions,
    _getTags,
    _loadTabs,
    _getEventNameByLocation
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._loadTabs(true)
  }

  $scope.$watchCollection('template', () => {
    $scope.flags.loadingContent = true
    const isTemplate = !$scope.template.assetId || $scope.template.assetId !== $scope.template.id
    const { needApproval } = $scope.template

    if (isTemplate) {
      TemplateService.getTemplateDetailsForPreview($scope.template.id)
        .then(api._handleTemplateDetails)
    } else {
      AssetService.getAssetDetailsById($scope.template.id).then(details => {
        $scope.details = details
      })
    }

    if (!needApproval && $scope.location === 'materialsCustomization') {
      $timeout(() => {
        $scope.assetTabs = $scope.allAssetTabs.filter((tab) => tab.name !== 'comments')
      }, 100, true)
    }
  })

  $scope.$watchCollection('previewFlags.tabHasNewComment', () => {
    api._loadTabs()
    const eventName = api._getEventNameByLocation($scope.location)
    if (eventName) {
      $rootScope.$broadcast(eventName)
    }
  })

  $scope.changeTab = (tabName) => {
    if ($scope.previewFlags.currentTab === tabName && $scope.previewFlags.tabsIsOpen) {
      $scope.previewFlags.tabsIsOpen = false
      $scope.previewFlags.currentTab = ''
    } else {
      $scope.previewFlags.tabsIsOpen = true
      $scope.previewFlags.currentTab = tabName
    }
  }

  $scope.copyUsageInstructions = () => {
    if (!$scope.usageInstructions) {
      return
    }

    const text = $scope.usageInstructions
    const sanitizedText = text ? text.$$unwrapTrustedValue().replace(/(<br>|<br \/>)/g, '\r\n').replace(/<[^>]*>/g, '').replace(/(&nbsp;)/g, ' ') : ''
    navigator.clipboard.writeText(sanitizedText)

    ToastService.showSuccessToast($translate.instant('copied'))
  }

  $scope.truncateText = api._truncateText

  $scope.getCampaignInfoBannerText = () => {
    return $translate.instant('campaignInfoBanner.material', { campaignName: $scope.details?.campaignName })
  }

  function _handleTemplateDetails (template) {
    $scope.details = template
    $scope.title = template.name
    $scope.productTitle = template.product?.name || '-'
    $scope.approval = template.needApproval ? $translate.instant('yes') : $translate.instant('no')
    $scope.expirationDate = template.templateExpirationDate ? api._formatDate(template.templateExpirationDate) : null

    api._getTemplateDimensions(template)
    api._getTags(template)
    api._getAssetType(template)
    api._getSize(template)
    api._getInstructions(template)

    $scope.flags.loadingContent = false
  }

  function _getSize (details) {
    if (!details.asset?.size) {
      return
    }

    $scope.size = Utils.getReadableFileSizeString(details.asset.size)
  }

  function _getTags (template) {
    if (!template?.tags?.length) {
      return
    }

    $scope.categories = template.tags.map(tag => ({
      id: tag.id,
      name: tag.name
    }))
  }

  function _getInstructions (template) {
    if (!template) {
      return
    }

    $scope.usageInstructions = $sce.trustAsHtml(template?.details?.suggestions)
  }

  function _getTemplateDimensions (template) {
    const layer = template?.layers?.[0]
    const height = layer?.height
    const width = layer?.width

    if (height || width) {
      $scope.dimensions = `${width} x ${height} px`
      return
    }

    $scope.dimensions = '-'
  }

  function _getAssetType (details) {
    $scope.type = details.isCustomizable
      ? $translate.instant('template')
      : details.asset?.extension.toUpperCase()
  }

  function _formatDate (dateISO = new Date()) {
    const configOptions = {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }

    const locale = $rootScope.oUser.locale
    const date = new Date(dateISO)
    return new Intl.DateTimeFormat(locale, configOptions).format(date)
  }

  function _truncateText (text, limit) {
    const lengthLimit = limit || 28

    if (text?.length > lengthLimit) {
      return text.slice(0, lengthLimit) + '...'
    } else {
      return text
    }
  }

  function _loadTabs (firstLoading) {
    $timeout(() => {
      $scope.allAssetTabs = [
        {
          name: 'info',
          tooltip: $translate.instant('information'),
          icon: 'info',
          locations: ['workflow', 'materials', 'posts', 'brand', 'materialsCustomizations', 'materialsApproval', 'briefing'],
          hasNotification: false
        },
        {
          name: 'comments',
          tooltip: $translate.instant('comments'),
          icon: 'message-square',
          locations: ['workflow', 'materialsCustomizations', 'materialsApproval'],
          hasNotification: $scope.previewFlags.tabHasNewComment
        },
        {
          name: 'instructions',
          tooltip: $translate.instant('usageInstructions'),
          icon: 'file-text',
          locations: ['materials', 'materialsApproval', 'materialsCustomizations'],
          hasNotification: false
        }
      ]

      $scope.assetTabs = $scope.allAssetTabs.filter((tab) => {
        return tab.locations?.find(location => location === $scope.location)
      })

      if (firstLoading && $scope.contextData?.openTab) {
        $scope.changeTab($scope.contextData.openTab)
      }
    })
  }

  function _getEventNameByLocation (location) {
    const screens = {
      materialsApproval: 'reload-approval-list'
    }

    if (screens[location]) return screens[location]
    return ''
  }
}

export { AssetPreviewTabsUserController }
